export enum CameraStatusEnum {
    ENABLED = 'ENABLED',
    DISBALED = 'DISABLED',
    DELETED = 'DELETED',
    CONCLUDED = 'CONCLUDED',
    CONCLUDING = 'CONCLUDING',
    RESTORING = 'RESTORING',
    ERROR = 'ERROR',
}
